import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { HotPropertyRequestBody, HotPropertyResponse } from "./types";

export class HotPropertyAPI extends BaseAPI<
    HotPropertyRequestBody,
    HotPropertyResponse
> {
    protected route = ApiRoutes.home.hot_property;
    protected method = RequestMethod.GET;
}
